/**
 * CurrencyInput — text input that displays whole-dollar formatting ($1,200)
 * when not focused, and the raw numeric value when focused for easy editing.
 *
 * Calls onChange on every keystroke with the parsed value (or null when
 * empty) so the parent's row state stays current — the row's onBlur=onCommit
 * save path keeps working unchanged.
 */

import React, { useState } from 'react';
import { formatCurrency, parseCurrencyInput } from './formatters';

interface CurrencyInputProps {
  value: number | null;
  onChange: (v: number | null) => void;
  className?: string;
  disabled?: boolean;
}

export const CurrencyInput: React.FC<CurrencyInputProps> = ({
  value,
  onChange,
  className,
  disabled,
}) => {
  const [focused, setFocused] = useState(false);
  const [draft, setDraft] = useState<string>('');

  const display = focused ? draft : value == null ? '' : formatCurrency(value);

  return (
    <input
      type="text"
      inputMode="decimal"
      value={display}
      onFocus={() => {
        setFocused(true);
        setDraft(value == null ? '' : String(value));
      }}
      onBlur={() => setFocused(false)}
      onChange={(e) => {
        setDraft(e.target.value);
        onChange(parseCurrencyInput(e.target.value));
      }}
      className={className}
      disabled={disabled}
    />
  );
};
